import React from 'react';

import _ from 'lodash';

import AlertConfigurationTableRow from './AlertConfigurationTableRow';

import AlertConfiguration from '../../Entities/AlertConfiguration';

import './AlertConfigurationTable.scss';


class AlertConfigurationTable extends React.Component {
  _onAlertConfigurationChange(alertType) {
    return value => {
      const alertConfigurations = _.cloneDeep(this.props.alertConfigurations);

      const existingIndex = alertConfigurations.findIndex(alertConfiguration => alertConfiguration.fields.type.value === alertType);
      if (existingIndex > -1) {
        alertConfigurations.splice(existingIndex, 1, value);
      }
      else {
        alertConfigurations.push(value);
      }

      this.props.onAlertConfigurationChange(alertConfigurations);
    };
  }


  render() {
    const {
      alertConfigurations,
      inputId,
      fieldConfiguration,
      editMode
    } = this.props;

    const alertConfigurationTableRows = fieldConfiguration.type.options.map(alertType => {
      const alertConfiguration = alertConfigurations.find(alertConfiguration => alertConfiguration.fields.type.value === alertType.value) ||
        new AlertConfiguration(alertType.value);

      return {
        alertTypeValue: alertType.value,
        alertTypeLabel: alertType.label,
        alertConfiguration
      };
    });

    return (
      <div className="parkchirp--alert-configuration-table">
        <header className="parkchirp--alert-configuration-table--header">
          <div className={`parkchirp--alert-configuration-table--cell` +
            ` parkchirp--alert-configuration-table--alert-type-column`}>
            <span className="parkchirp--alert-configuration-table--column-heading">Alert Type</span>
          </div>
          <div className={`parkchirp--alert-configuration-table--cell` +
            ` parkchirp--alert-configuration-table--alert-recipients-column`}>
            <span className="parkchirp--alert-configuration-table--column-heading">Recipients</span>
          </div>
        </header>
        <div className="parkchirp--alert-configuration-table--body">
          {alertConfigurationTableRows.map(alertConfigurationRow => {
            return (
              <AlertConfigurationTableRow key={alertConfigurationRow.alertTypeValue}
                data={alertConfigurationRow}
                onAlertConfigurationChange={this._onAlertConfigurationChange(alertConfigurationRow.alertTypeValue)}
                inputId={inputId}
                editMode={editMode}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
export default AlertConfigurationTable;
